import React from "react";
import styles from "./Input.module.css";

function Input(props) {
  return (
    <>
      {props.label && <label className={styles.label} htmlFor={props.id}>{props.label}</label>}
      <input
        id={props.id}
        type={props.type || "text"}
        placeholder={props.placeholder}
        onChange={props.onChange}
        className={`${styles.input} ${props.disabled ? styles.disabled : ""}`}
        name={props.name}
        value={props.value}
        disabled={props.disabled}
      />
    </>
  );
}

export default Input;
